<template>
  <!-- 员工列表 -->
  <div class="container">
    <div class="vue">
      <div class="header flex flexAi-c">
        <div class="text primaryCol">员工列表</div>
        <el-button
          class="butSmallH"
          @click="dialogVisible = true"
          type="primary"
          size="small"
          >添加员工</el-button
        >
      </div>
      <el-table height="72vh" :data="UserData.list" style="width: 100%">
        <el-table-column label="创建时间" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="180">
        </el-table-column>
        <el-table-column prop="tel" label="手机号"> </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            <span>{{ scope.row.sex | FilterNumber('男', '女') }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="editClick(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-popover
              class="padHorizontal10"
              placement="top"
              width="180"
              :ref="`popover-${scope.$index}`"
            >
              <p>确定要将此条数据删除吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button
                  size="mini"
                  type="text"
                  @click="
                    scope._self.$refs[`popover-${scope.$index}`].doClose()
                  "
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    cancelClick(
                      scope.row,
                      scope._self.$refs[`popover-${scope.$index}`].doClose()
                    )
                  "
                  >确定</el-button
                >
              </div>
              <el-button slot="reference" type="text" size="small"
                >删除</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" v-if="UserData.list != null || UserData != ''">
        <el-pagination
          background
          :current-page="page"
          :page-size="UserData.pageSize"
          layout="prev, pager, next, jumper"
          :total="UserData.total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="添加员工"
      :visible.sync="dialogVisible"
      width="30%"
      @close="dialogClose"
    >
      <div class="contan">
        <el-form size="small" :model="Userform" label-width="80px">
          <el-form-item label="姓名">
            <el-input v-model="Userform.name"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-select
              style="width:100%"
              v-model="Userform.sex"
              placeholder="请选择性别"
            >
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="Userform.tel"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="Userform.password"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBut">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 导入我们的api接口
import { apiAddUser, apiUserFindAll, apiDelUser } from '@/api/backgroundViews'
export default {
  name: '',
  props: [''],
  data() {
    return {
      tableData: [{}, {}],
      dialogVisible: false,
      page: 1, // 当前页数
      size: 10,
      Userform: {
        name: '',
        sex: '0',
        tel: '',
        password: ''
      },
      list: [
        '名字不能为空！',
        '性别不能为空！',
        '手机号不能为空！',
        '密码不能为空！'
      ],
      UserData: '' // 用户列表
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.UserFindAll()
  },

  methods: {
    // 弹窗关闭回调
    dialogClose() {
      this.Userform = {
        name: '',
        sex: '0',
        tel: '',
        password: ''
      }
    },
    // 添加成员
    confirmBut() {
      console.log(this.Userform.sex)
      if (this.objNaN(this.Userform, this.list)) {
      } else {
        apiAddUser({
          name: this.Userform.name,
          sex: this.Userform.sex,
          tel: this.Userform.tel,
          password: this.Userform.password
        }).then(res => {
          if (res.status === '0') {
            this.dialogVisible = false
            this.$message({
              msg: res.msg,
              type: 'success'
            })
          }
        })
      }
    },
    // 列表编辑
    editClick(row) {
      console.log(row)
      this.Userform.name = row.name
      this.Userform.tel = row.tel
      this.Userform.sex = row.sex.toString()
      this.dialogVisible = true
    },
    // 列表删除
    cancelClick(row) {
      apiDelUser({
        id: row.id
      }).then(res => {
        if (res.status === '0') {
          this.$Ms(res.msg)
          this.UserFindAll()
        } else if (res.status === '1') {
          this.$Me(res.msg)
        }
      })
    },
    // 分页
    handleCurrentChange(e) {
      this.page = e
      this.UserFindAll()
      console.log(`当前页: ${e}`)
    },
    /*
     *接口
     */
    // 查询全部员工
    UserFindAll() {
      apiUserFindAll({
        page: this.page,
        size: this.size
      }).then(res => {
        if (res.status === '0') {
          this.UserData = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
$padding: 10px;
$colorMajor: #005ca1;
.vue {
  text-align: left;
  background-color: #fff;
  padding: $padding;
  .header {
    border-bottom: 1px solid #f3f3f3;
    justify-content: space-between;
    .text {
      text-align: left;
      padding: 10px 5px;
    }
  }
  .but {
    padding-bottom: $padding - 2px;
  }
  .block {
    text-align: right;
    padding: 10px 20px;
  }
}
</style>
